import { render, staticRenderFns } from "./searchKeys.vue?vue&type=template&id=6c45d835&"
import script from "./searchKeys.vue?vue&type=script&lang=js&"
export * from "./searchKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports